<template>
  <v-layout row wrap>
    <YesNoModal ref="YesNoModal" />
    <ErrorModal ref="ErrorModal"></ErrorModal>
    <Loader ref="Loader"></Loader>
    <v-flex xs12>
      <v-toolbar dense dark>
        <v-toolbar-title>Meetings</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn icon dark color="success" @click="addNewMeeting" large>
          <v-icon>mdi-plus</v-icon>
        </v-btn>
      </v-toolbar>
    </v-flex>

    <v-flex xs12>
      <v-list two-line>
        <v-list-group v-for="item in MeetingList" :key="item.ID">
          <template v-slot:activator>
            <v-list-tile>
              <v-list-tile-content>
                <v-list-tile-title>{{ item.MeetingDetail.Name }}</v-list-tile-title>
                <v-list-tile-sub-title>{{item.MeetingDetail.Subject}}</v-list-tile-sub-title>
              </v-list-tile-content>
            </v-list-tile>
          </template>

          <v-list-tile v-for="subItem in item.MeetingTasks" :key="subItem.ID">
            <v-list-tile-avatar class="pl-2">
              <v-icon>mdi-calendar-check</v-icon>
            </v-list-tile-avatar>
            <v-list-tile-content @click="viewTask(subItem)">
              <v-list-tile-title>{{ subItem.Name }}</v-list-tile-title>
              <v-list-tile-sub-title>{{ filterSystemUser(subItem.SystemUserID) }}</v-list-tile-sub-title>
            </v-list-tile-content>

            <v-list-tile-action>
              <v-chip v-if="subItem.Complete" outline color="green" text-color="black" selected>
                <v-avatar class="green">C</v-avatar>Complete
              </v-chip>
              <v-chip v-else outline color="orange" text-color="black" selected>
                <v-avatar class="orange">P</v-avatar>Pending
              </v-chip>
            </v-list-tile-action>
          </v-list-tile>
        </v-list-group>
      </v-list>
    </v-flex>
    <v-dialog v-model="taskDialog" width="500">
      <v-card class="pa-1">
        <v-flex xs12>
          <v-form>
            <v-layout row align-center>
              <v-subheader>
                <v-icon class="mr-2">mdi-calendar</v-icon>
                {{taskDialogData.Name}}
              </v-subheader>
              <v-spacer></v-spacer>
              <v-btn small color="success" round ripple @click="completeTask">complete!</v-btn>
            </v-layout>
            <v-layout justify-end>
              <v-btn small color="secondary" v-if="taskDialogData.FilePath != '' && taskDialogData.FilePath != null"
                round ripple @click="showImage(taskDialogData)">Show image</v-btn>
            </v-layout>
          </v-form>
        </v-flex>
      </v-card>
    </v-dialog>

    <v-dialog width="500" v-model="taskOverviewDialog">
      <v-card>
        <TaskOverview :meetingID="overviewID" />
        <v-layout>
          <v-spacer></v-spacer>
          <v-btn color="success" small @click="taskOverviewDialog = false">Done</v-btn>
        </v-layout>
      </v-card>
    </v-dialog>
  </v-layout>
</template>

<script>
  import moment from "moment";

  import TaskOverview from "./tasks/meeting-task-overview";

  export default {
    components: {
      TaskOverview
    },
    data() {
      return {
        taskDialog: false,
        taskDialogData: {
          Name: null
        },
        taskOverviewDialog: false,
        newTaskAssigned: false,
        overviewID: -1,
        MeetingList: [],
        SystemUserList: [],
        rootPath: "",
        systemUserID: 0,
        CanFetch: false,
      };
    },
    mounted() {
      this.checkConnection();
      setTimeout(() => {
        if (this.CanFetch == true) {
          this.fetchSystemUsers();
          this.systemUserID = parseInt(localStorage.getItem('USER_ID'));
          console.log('userID', this.systemUserID)
          this.fetchData();
        }
      }, 100)
      this.rootPath = this.$route.matched[0].path;
    },
    methods: {
      checkConnection(e) {
        let self = this;
        try {
          var connection =
            navigator.connection ||
            navigator.mozConnection ||
            navigator.webkitConnection;
          var type = connection.type;
          if (connection) {
            //CONNECTED VIA PC
            if (connection.type === undefined) {
              console.log("[CONNECTED VIA PC]");
              this.CanFetch = true;
            }

            //MOBILE
            if (connection.type === "cellular") {
              this.CanFetch = true;
              console.log("[CONNECTED VIA MOBILE] - CELLULAR");
            } else if (connection.type === "wifi") {
              this.CanFetch = true;
              console.log("[CONNECTED VIA MOBILE] - WIFI");
            }
            console.log("[CONNECTION TYPE]", connection);
          }
        } catch (error) {
          this.CanFetch = false;
          console.warn(
            "[CONNECTION TYPE] IOS, could not determine connection type for safari. Will use any form of data to upload",
            error, error.toString());
        }
      },
      fetchData() {
        let self = this;
        self.MeetingList = [];

        self.get(`Meeting/GetAllComplex?systemUserID=${self.systemUserID}`).then(r => {
          console.log("MEETING DATA", r.data)
          r.data.forEach(meeting => {
            if (meeting.MeetingSystemUsers.length != 0) {
              console.log(r.data);
              self.MeetingList.push(meeting);
            }
            console.log("[MEETING LIST]", self.MeetingList)
          })
        })
        // self.get(`Meeting/GetAllComplex`).then(r => {
        //   if (r.data != null) {
        //     console.log(r.data);
        //     self.MeetingList = r.data;
        //   }
        // });
      },
      fetchSystemUsers() {
        let self = this;

        self.get(`SystemUser/getAll`).then(r => {
          self.SystemUserList = r.data;
        });
      },
      openTaskOverview(meeting) {
        let self = this;

        self.overviewID = meeting.ID;
        self.taskOverviewDialog = true;
      },
      viewTask(task) {
        let self = this;
        self.taskDialogData = task;
        self.taskDialog = true;
      },
      completeTask() {
        let self = this;
        let id = self.taskDialogData.ID;
        self.post(`MeetingTask/CompleteTask?id=${id}`).then(r => {
          if (r.data) {
            self.fetchData();
            self.taskDialog = false;
          }
        });
      },
      addNewMeeting() {
        this.$router.push(`${this.rootPath}/Meeting/Create`);
      },
      formatDate(date) {
        return moment(date).format("YYYY-MM-DD");
      },
      filterSystemUser(systemUserID) {
        let self = this;

        let systemUser = self.SystemUserList.find(filter => {
          return filter.ID == systemUserID;
        });

        if (systemUser != undefined) {
          return systemUser.FirstName + " " + systemUser.LastName;
        }
      }
    }
  };
</script>

<style>
  .fade-enter-active,
  .fade-leave-active {
    transition: opacity 0.5s;
  }

  .fade-enter,
  .fade-leave-to

  /* .fade-leave-active below version 2.1.8 */
    {
    opacity: 0;
  }
</style>